export function joinPath(...args: string[]): string {
  return args.join("/");
}
